import React, { useEffect, useState } from "react";
import { IntlProvider } from "react-intl";
import { useSelector } from "react-redux";
import PropTypes from "prop-types";

import messagesEn from "./translations/en.json";
import messagesEs from "./translations/es.json";

/**
 * I18nProvider
 * @param {object} props
 * @param {React.ReactNode} props.children
 */
export const I18nProvider = ({ children }) => {
  const locale = useSelector(state => state.app.locale.split("-")[0]);
  const [messages, setMessages] = useState(locale === "en" ? messagesEn : messagesEs);

  useEffect(() => {
    setMessages(locale === "en" ? messagesEn : messagesEs);
  }, [locale]);

  return (
    <IntlProvider defaultLocale="en" locale={locale} messages={messages} key={locale}>
      {children}
    </IntlProvider>
  );
};

I18nProvider.propTypes = {
  children: PropTypes.node,
};

I18nProvider.defaultProps = {
  children: null,
};

export default I18nProvider;
